// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"ArticleCard_cardContainer__Fmlvd","textContainer":"ArticleCard_textContainer__7SAbo"};